import { render, staticRenderFns } from "./CardRegistrationButton.vue?vue&type=template&id=42d99a41&scoped=true"
import script from "./CardRegistrationButton.vue?vue&type=script&lang=js"
export * from "./CardRegistrationButton.vue?vue&type=script&lang=js"
import style0 from "./CardRegistrationButton.vue?vue&type=style&index=0&id=42d99a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d99a41",
  null
  
)

export default component.exports